
const routes = [
  {
    path: '/',
    component: () => import('layouts/Default.vue'),
    children: [
      {
        path: '', component: () => import('pages/Index.vue'), meta: { requiresAuth: true },
      },
      { path: 'shifts', component: () => import('pages/Index.vue'), meta: { requiresAuth: true } },
      { path: 'login', component: () => import('pages/Login.vue') },
      { path: 'allShifts', component: () => import('pages/Shifts.vue'), meta: { requiresAuth: true } },
      { path: 'messages', component: () => import('pages/Messages.vue'), meta: { requiresAuth: true } },
    ],
  },
];

// Always leave this as last one
routes.push({
  path: '*',
  component: () => import('pages/Error404.vue'),
});


export default routes;
